import { FC } from 'react';
import { Breadcrumb, Card, PageHeader } from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ImageForm from '../components/forms/image-form';

const ImagesFormRoute: FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const id = searchParams.get('id')
  return (
    <>
      <PageHeader
        title="فرم تصویر"
        style={{ padding: " 16px 0" }}
        onBack={() => navigate(-1)}
        />
      <Card >
        <ImageForm id={id} />
      </Card>
    </>
  );
}

export default ImagesFormRoute;
